// extracted by mini-css-extract-plugin
module.exports = {"wave":"OverlayWaves_wave__2yydj","front":"OverlayWaves_front__2AvYc","second":"OverlayWaves_second__1Duob","wave2":"OverlayWaves_wave2__12caj","swell":"OverlayWaves_swell__MKyw8"};